export type SchemaPermissionLevel = 'manager' | 'editor' | 'viewer';

export interface SchemaPermissionNode {
  name: string;
  hierarchy: string;
  nodeUUID: string;
  nodeLabel: string;
}

export interface UserSchemaPermission extends SchemaPermissionNode {
  permission: SchemaPermissionLevel;
}

export type SchemaPermissionAssignment = [
  userUUID: string,
  permission: SchemaPermissionLevel
];
